import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export class BlankDialogButton {
  name: string;
  clazz: string;
}

@Component({
  selector: 'app-dialog',
  templateUrl: './blank-dialog.component.html',
  styleUrls: ['./blank-dialog.component.scss']
})
export class BlankDialogComponent implements OnInit {

  @Output()
  public action = new EventEmitter<string>();

  @Output()
  public finished = new EventEmitter();

  @Input()
  public header = 'Título do modal';

  @Input()
  public icon = 'fal fa-question-circle';

  @Input()
  public cancelButtonLabel = 'Cancelar';

  @Input()
  public confirmButtonLabel = 'Confirmar';

  @Input()
  public confirmation: Observable<any>;

  @Input()
  public overwriteToolbar = false;

  @Input()
  public secret: string;

  public isConfirming = false;

  constructor(
    private dialogRef: MatDialogRef<BlankDialogComponent>,
  ) { }

  ngOnInit(): void {
  }

  public confirmPressed() {
    this.isConfirming = true;
    this.confirmation
    .pipe(finalize(() => this.isConfirming = false))
    .subscribe(result => this.finished.emit(result));
  }

  public openSecret() {
    if (this.secret && this.secret.startsWith('https://')) {
      window.open(this.secret, '_blank');
    }
  }


}
